import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.show,
      "title": _vm.$t('Dashboards.components.actionsEditor.dialog.actionParameters.title', {
        action: _vm.action.label
      }),
      "action-save-label": _vm.$t('Common.save')
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('input', false);
      },
      "action:save": _vm.saveActionParameters
    }
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.saveActionParameters.apply(null, arguments);
      }
    }
  }, _vm._l(_vm.visibleParameterDefinitions, function (parameter, index) {
    return _c(VRow, {
      key: `action-parameter-${index}`
    }, [_c(VCol, [parameter.type === 'boolean' ? _c(VSwitch, {
      attrs: {
        "color": _vm.color,
        "label": parameter.label,
        "input-value": _vm.temporaryActionParameters[parameter.key]
      },
      on: {
        "change": function ($event) {
          return _vm.updateActionParameter(parameter.key, parameter.type, $event);
        }
      }
    }) : parameter.type === 'twin.id' ? _c('core-dtwin-finder', {
      attrs: {
        "value": _vm.temporaryActionParameters[parameter.key],
        "label": parameter.label,
        "required": parameter.required,
        "hideDetails": "",
        "enabled": !!_vm.dashboard,
        "tenant-id": _vm.dashboard ? _vm.dashboard.identifier.tenantId : null,
        "same-tenant": "",
        "skip-tenant-check-for-fetch-of-selected-twin": "",
        "skip-disabled-check-for-fetch-of-selected-twin": ""
      },
      on: {
        "input": function ($event) {
          return _vm.updateActionParameter(parameter.key, parameter.type, $event);
        }
      }
    }) : parameter.type === 'nestedDashboard' ? _c('nested-dashboard-options-editor', {
      attrs: {
        "value": _vm.temporaryActionParameters[parameter.key] || {},
        "custom-parameters": _vm.customParameters
      },
      on: {
        "input": function ($event) {
          return _vm.updateActionParameter(parameter.key, parameter.type, $event);
        }
      }
    }) : _c(VTextField, {
      attrs: {
        "label": parameter.label,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "type": parameter.type,
        "value": _vm.temporaryActionParameters[parameter.key],
        "required": parameter.required,
        "rules": parameter.required ? [_vm.rules.required] : []
      },
      on: {
        "input": function ($event) {
          return _vm.updateActionParameter(parameter.key, parameter.type, $event);
        }
      }
    })], 1)], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };